import React from 'react';
import PropTypes from 'prop-types';
import SinglePost from './SinglePost';


export const SingleThreadPosts = (props) => {

    const { posts } = props;

    return (
        <ul className="posts-list">
            {
                posts && posts.length > 0 && posts.map((post, index) =>
                    <SinglePost key={index} post={post} person={post.person} />
                )
            }
        </ul>
    );
};

SingleThreadPosts.propTypes = {
    posts: PropTypes.array
}



// WEBPACK FOOTER //
// src/client/components/site/features/forums/pages/elements/SingleThreadPosts.js